// Parse Google Places opening hours stored as raw JSON in a metafield,
// and render them as readable per-day opening/closing times.
// The negozio template outputs the raw JSON in the first <p> of the
// [data-store-hours-source] wrapper, followed by the legacy manually
// entered per-day hours. If the JSON is missing or can't be turned into
// per-day hours, only the JSON paragraph is removed so the legacy hours
// stay visible as a fallback.
// The wrappers are CSS-hidden by theme.liquid until this script has run,
// so the raw JSON is never painted; reveal them whatever happens below.
(function () {
  var sources = document.querySelectorAll("[data-store-hours-source]");

  try {
    var sourceEl = sources[0];
    if (!sourceEl) return;

    var jsonEl = sourceEl.querySelector("p");
    if (!jsonEl) return;

    var raw = jsonEl.textContent.trim();
    var looksLikeJson = raw.charAt(0) === "{" && raw.indexOf('"currentOpeningHours"') !== -1;

    // First paragraph already holds legacy hours (empty metafield <p> was
    // stripped by the richtext renderer): leave everything untouched.
    if (raw !== "" && !looksLikeJson) return;

    var html = "";
    if (looksLikeJson) {
      try {
        var data = JSON.parse(raw);
        var periods = data.currentOpeningHours.periods;
        var dayNames = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"];

        // Bucket periods by day (0=Sunday in Google, we reorder to Monday-first below)
        var buckets = [[], [], [], [], [], [], []];
        for (var i = 0; i < periods.length; i++) {
          buckets[periods[i].open.day].push(periods[i]);
        }

        // Reorder: Monday (day 1) through Sunday (day 0)
        var daysInOrder = [
          buckets[1], // Monday
          buckets[2], // Tuesday
          buckets[3], // Wednesday
          buckets[4], // Thursday
          buckets[5], // Friday
          buckets[6], // Saturday
          buckets[0], // Sunday
        ];

        var formatTime = function (time) {
          var hh = String(time.hour || 0).padStart(2, "0");
          var mm = String(time.minute || 0).padStart(2, "0");
          return hh + ":" + mm;
        };

        for (var d = 0; d < 7; d++) {
          var slots = daysInOrder[d];
          if (slots.length) {
            var formatted = slots
              .map(function (slot) {
                // slot.close is absent for always-open places: accessing it
                // throws, so we fall back to the legacy hours below.
                return formatTime(slot.open) + "-" + formatTime(slot.close);
              })
              .join(", ");
            html += "<p><strong>" + dayNames[d] + "</strong> " + formatted + "</p>";
          } else {
            html += "<p><strong>" + dayNames[d] + "</strong> CHIUSO</p>";
          }
        }
      } catch (e) {
        html = "";
      }
    }

    if (html) {
      sourceEl.innerHTML = html;
    } else {
      // JSON missing or unusable: drop its paragraph, keep the legacy hours.
      jsonEl.remove();
    }
  } finally {
    for (var s = 0; s < sources.length; s++) {
      sources[s].style.visibility = "visible";
    }
  }
})();
